import React from 'react';
import { Tooltip, IconButton, InputAdornment } from '@barracuda-internal/bds-core-v2';
import ClearIcon from '@mui/icons-material/Clear';

export const SearchEndAdornment: React.FC<{
  searchValue: string;
  isSearchFocused: boolean;
  scanlogsSearchFields: string[];
  onClear: () => void;
}> = ({ searchValue, isSearchFocused, scanlogsSearchFields, onClear }) => (
  <>
    <Tooltip
      title={
        <span style={{ padding: '4px', display: 'block' }}>
          {`Joe or <field>:<text> where field can be ${scanlogsSearchFields.join(', ')}`}
        </span>
      }
      open={isSearchFocused}
      placement="bottom"
      arrow
      slotProps={{
        popper: {
          modifiers: [
            {
              name: 'offset',
              options: { offset: [0, 10] },
            },
          ],
        },
      }}
    >
      <span style={{ display: 'inline', width: '100%', position: 'absolute' }} />
    </Tooltip>
    {searchValue && (
      <InputAdornment position="end" sx={{ ml: 0 }}>
        <IconButton
          aria-label="clear"
          bdsSize="medium"
          onClick={onClear}
        >
          <ClearIcon fontSize="inherit" />
        </IconButton>
      </InputAdornment>
    )}
  </>
);